export default "__VITE_ASSET__BmMASIvM__"